export enum FedopsInteraction {
  ViewStepAtSidebarLayout = 'view-step-at-sidebar-layout',
  CompleteStepWithoutFeedback = 'complete-step-without-feedback',
  UpdateFeedbackData = 'update-feedback-data',
  LeaveFromProgram = 'leave-from-program',
}
